import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { getColorway } from 'utils/styles';
import { FaqProps } from 'libs/contentful/props';
import Schema from 'components/shared/Schema/Schema';
import { getRichTextValue, getColorwayName } from 'utils/formatters';
import ToggleMenu from './ToggleMenu';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export const Faq = ({ sys, sectionName, color, headline, toggleItems }: FaqProps) => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: toggleItems.items.map(toggleItem =>
      toggleItem.contentCollection.items.map(accordionItem => ({
        '@type': 'Question',
        name: accordionItem.accordionLabelRte ? getRichTextValue(accordionItem.accordionLabelRte) : '',
        acceptedAnswer: {
          '@type': 'Answer',
          text: accordionItem.accordionCopy ? getRichTextValue(accordionItem.accordionCopy) : '',
        },
      })),
    ),
  };

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={`${getColorway(color)} all-margins`}>
      {jsonLd && <Schema jsonLd={jsonLd} />}
      <div className="content-wrapper">
        {headline && (
          <div
            className="font-sans font-semibold text-heading-md md:text-heading-lg"
            {...liveUpdateAttrs(sys?.id, 'headline')}>
            <RichTextHeadline headline={headline} />
          </div>
        )}
        <ToggleMenu toggleItems={toggleItems.items} sys={sys} color={getColorwayName(color)} />
      </div>
    </section>
  );
};

export default Faq;
